/* Poke-Geek V2 — libellé durable pour les différentes langues d'import. */
(() => {
  const updateImportLabel = (root = document) => {
    root.querySelectorAll('.pg-cedar-hero__facts').forEach((facts) => {
      const importLink = facts.querySelectorAll('a')[1];
      if (!importLink || importLink.dataset.pgAsianImportsReady === 'true') return;

      const title = importLink.querySelector('strong');
      const detail = importLink.querySelector('small');

      if (title) title.textContent = 'Imports asiatiques';
      if (detail) detail.textContent = 'JPN, CN et KR';
      importLink.dataset.pgAsianImportsReady = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => updateImportLabel());
  } else {
    updateImportLabel();
  }

  document.addEventListener('shopify:section:load', (event) => updateImportLabel(event.target));
})();
